import { TrackableType } from "@qendo/trackables";
import { useLocalSearchParams } from "expo-router";
import { PeriodForm } from "~/components/form/journal/PeriodForm";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useJournal } from "~/providers/JournalProvider";

export default function CreatePeriod() {
    const { date } = useLocalSearchParams<{ date?: string }>();
    const { handleDismiss } = useDismiss();
    const { canUpdateJournal } = useJournal();

    if (!canUpdateJournal(TrackableType.journal)) {
        return <Dismiss />;
    }

    return <PeriodForm onRequestClose={handleDismiss} onDate={date} asRoute />;
}
